import { postToParent, PARENT_SOURCE } from './messages.js';

export const embedHeight = () => {
	let lastHeight = 0;

	const report = (force = false) => {
		const height = Math.ceil(document.documentElement.getBoundingClientRect().height);
		if (!force && height === lastHeight) return;
		lastHeight = height;
		postToParent('height', { height });
	};

	new ResizeObserver(() => report()).observe(document.documentElement);
	window.addEventListener('load', () => report(true));

	// rodzic mógł załadować embed-parent.js dopiero po pierwszym pomiarze - odpowiadamy na jego ping
	window.addEventListener('message', (e) => {
		if (e.source !== window.parent || e.data?.source !== PARENT_SOURCE) return;
		if (e.data.type === 'ping') report(true);
	});
};
